import { WhitelistRoute } from "../constants/whitelistRoute";

export const redirectTo = (pathname, history) => {
  if (!WhitelistRoute[pathname]) {
    history.push("/");
  }
};
